import React from 'react';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col items-center justify-start min-h-screen bg-gray-100 dark:bg-neutral-900 px-4 py-8">
      {
        <div className="mb-8">
          <img src="images/logo.png" alt="Logo" style={{ height: '120px', maxWidth: 'auto' }} />
        </div>
      }
      <main className="w-full flex-grow"> {/* RegistroWizard ya tiene su propio max-w-2xl y container */}
        {children}
      </main>
      { 
        <footer className="mt-8 text-center text-sm text-gray-500">
          © EnBici {new Date().getFullYear()}. Todos los derechos reservados.
        </footer>
      }
    </div>
  );
};

export default PublicLayout;